import { render, staticRenderFns } from "./OrbitRemoveOwnerModal.vue?vue&type=template&id=ddca404a"
import script from "./OrbitRemoveOwnerModal.vue?vue&type=script&lang=ts"
export * from "./OrbitRemoveOwnerModal.vue?vue&type=script&lang=ts"
import style0 from "./OrbitRemoveOwnerModal.vue?vue&type=style&index=0&id=ddca404a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports